import React, { forwardRef } from "react"
import { radioButtonsGroup, marginBottomNone } from "./RadioButton.css"

export type RadioButtonOptionType = {
  value: string
  label: React.ReactNode | string
}

type RadioButtonGroupProps = {
  children: React.ReactNode
  styles?: string
  removeSpaceBetween?: boolean
}

export const RadioButtonGroup = forwardRef<
  HTMLDivElement,
  RadioButtonGroupProps
>(({ children, styles = "", removeSpaceBetween = false }, ref) => {
  return (
    <div
      ref={ref}
      data-testid="radio-buttons-container"
      className={`${radioButtonsGroup} ${styles} ${
        removeSpaceBetween ? marginBottomNone : ""
      }`}
    >
      {children}
    </div>
  )
})
